export default "__VITE_ASSET__62684a49__"